import DOMPurify from "dompurify";

/**
 * Sanitize stored rich text for display and make every external link open in a new tab.
 *
 * DOMPurify strips `target`, so links inside posts used to navigate away from the app
 * (reported 2026-08-18). We re-apply it here rather than allow-listing the attribute,
 * so `rel` is guaranteed alongside it and internal links (mentions, /profile paths) are
 * left to the router.
 */
export const sanitizeRichHtml = (html) => externalLinksToNewTab(DOMPurify.sanitize(html || ""));

export const externalLinksToNewTab = (html) => {
  if (!html || !html.includes("<a")) return html;
  const doc = new DOMParser().parseFromString(`<div id="__r">${html}</div>`, "text/html");
  doc.getElementById("__r").querySelectorAll("a[href]").forEach((a) => {
    const href = a.getAttribute("href") || "";
    if (!/^https?:\/\//i.test(href) || a.hasAttribute("data-mention")) return;
    a.setAttribute("target", "_blank");
    a.setAttribute("rel", "noopener noreferrer nofollow");
  });
  return doc.getElementById("__r").innerHTML;
};
